<template>
  <!--发送消息通用弹出文本域框-->
  <popup :value="value" @input="changeShow" :hide-on-blur=true>
    <div class="send-msg-wrapper">
      <h3 class="title">
        {{ title }}
        <i @click="close">&times;</i>
      </h3>
      <group>
        <x-textarea
          :rows="6"
          :max="128"
          v-model="msg"
          :placeholder="'请输入' + title"
          :show-counter="false"
        ></x-textarea>
      </group>
      <footer @click="confirm">确认</footer>
    </div>
  </popup>
</template>

<script>
// this.$emit('update:showTimeSelectPopup', newTitle)
import { Popup, XTextarea, Group } from '@lx-frontend/cvux'

export default {
  props: {
    title: {
      default: '取消预约原因',
      type: String
    },
    value: {
      default: false,
      type: Boolean
    },
    cb: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      msg: ''
    }
  },
  components: { Popup, XTextarea, Group },
  methods: {
    changeShow(val) {
      this.$emit('input', val)
    },
    // 关闭时间选择弹窗
    close() {
      this.changeShow(false)
    },
    confirm() {
      if (!this.msg) {
        this.showToast('请输入原因！')
        return
      }
      // this.$emit('input', this.value)
      this.cb(this.msg)
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn";
  .send-msg-wrapper {
    position: relative;
    height: 400/@w;
    background-color: #fff;

    .title {
      position: relative;
      height: 132/@w2;
      line-height: 132/@w2;
      text-align: center;
      font-size: 16px;
      color: #333;

      i {
        display: inline-block;
        position: absolute;
        font-size: 24/@w;
        top: -20/@w;
        right: 5/@w;
      }
    }

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50/@w;
      color: #fff;
      background-color: #5b93fc;
    }
  }
</style>
